import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import PT from 'prop-types';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as InnerSwitch } from './InnerSwitch/InnerSwitch-C6UJG3Cr.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const LabelCenterer = /*#__PURE__*/styled('label').withConfig({
  componentId: "sc-storm-ui-30062554__sc-1meqyfg-0"
})(["", ";color:", ";cursor:", ";", ""], ({
  theme
}) => theme.typography.base, ({
  disabled,
  theme
}) => disabled ? theme.form.label.colorDisabled : theme.form.label.color, ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', isMobile(css(["", ";"], ({
  theme
}) => theme.typography.mobile.base)));
const LabelArea = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-1meqyfg-1"
})(["display:inline-flex;margin-inline-start:", ";", ""], ({
  theme
}) => theme.spacing.small, isMobile(css(["margin-inline-start:", ";"], ({
  theme
}) => theme.mobile.spacing.small)));
const SwitchContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-1meqyfg-2"
})(["display:inline-flex;align-items:center;"]);
const Switch = ({
  disabled = false,
  id,
  label,
  renderLabelEnd,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('switch')
}, ({
  getDataTaktAttributes
}) => label ? /*#__PURE__*/React__default.createElement(SwitchContainer, null, /*#__PURE__*/React__default.createElement(InnerSwitch, _extends({}, getDataTaktAttributes(), rest, {
  id: id,
  disabled: disabled
})), /*#__PURE__*/React__default.createElement(LabelArea, null, /*#__PURE__*/React__default.createElement(LabelCenterer, _extends({}, getDataTaktAttributes({
  taktIdSuffix: 'label'
}), {
  htmlFor: id,
  disabled: disabled
}), label), renderLabelEnd && renderLabelEnd)) : /*#__PURE__*/React__default.createElement(InnerSwitch, _extends({}, getDataTaktAttributes(), rest, {
  id: id,
  disabled: disabled
})));
Switch.propTypes = {
  id: PT.string.isRequired,
  className: PT.string,
  /**
   * Denotes if the Switch should be toggled.
   */
  toggled: PT.bool,
  /**
   * Denotes if the Switch should be disabled.
   */
  disabled: PT.bool,
  /**
   * Returns callback of (value, event).
   */
  onChange: PT.func,
  /**
   * Denotes if the Switch should be small.
   */
  small: PT.bool,
  /**
   * Used to provide a customized aria-label to the Switch. For accessibility purposes only.
   */
  switchLabel: PT.string,
  /**
   * Denotes if the Switch should have label.
   */
  label: PT.node,
  /**
   * Denotes if the Switch label has data that should be rendered after the label.
   */
  renderLabelEnd: PT.node
};
Switch.defaultProps = {
  className: '',
  toggled: false,
  disabled: false,
  onChange: noop,
  small: false,
  switchLabel: undefined,
  label: undefined,
  renderLabelEnd: undefined
};

export { Switch as S };
//# sourceMappingURL=Switch-BeLvhpa9.js.map
